
"use strict";


/**
 * @type Controller
 * @name RundownDialogCtrl
 * @packageName rundown_dialog_ctrl.js
 *
 * @description
 *
 * The `RundownDialogCtrl` interaction delete mdDialog for rundown
 *
 */
class RundownDialogCtrl {


    constructor( $scope, $mdDialog) {

    	//Attach dependicies to class root
    	this.$mdDialog = $mdDialog;

    	//Ugly work around CANCEL button!
    	$scope.cancel = () => {
    		this.cancelButton();
    	};

		//Ugly work around OK button!
    	$scope.ok = () => {
    		this.ok();
    	};

    }


	/*
     * managed CANCEL event from confirm dailog
     */
    cancelButton () {
        this.$mdDialog.cancel();
    }


	/*
     * managed OK event from confirm dailog
     */
    ok () {
        this.$mdDialog.hide();
	}
}


/*
 * Inject dependicies
 */
RundownDialogCtrl.$inject = ['$scope', '$mdDialog'];


/*
 * Browsify connection: execute controller
 */
module.exports = RundownDialogCtrl;
